'use strict';

export default {
	FILE_LIST: 'File List',
	DEFAULT_FILE_LIST_CATEGORY: 'General'
};